export default "__VITE_ASSET__BfL4oggg__";